<template>
    <div class="help-text" ref="help">
        <button
            type="button"
            class="help-text__trigger"
            @click="togglePopover()">
            <i class="fa" :class="showPopover ? 'fa-times-circle' : 'fa-info-circle'"></i>
        </button>
        <transition name="bounce">
            <div
                class="help-text__popover"
                v-show="showPopover">
                <p v-text="helptext"></p>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        name: 'helptext',
        props: {
            helptext: {
                type: String,
                required: false,
                default: null
            }
        },
        data () {
            return {
                showPopover: false
            }
        },
        methods: {
            togglePopover () {
                this.showPopover = !this.showPopover
            },
            closeOnClickaway (e) {
                if (!this.$refs.help) {
                    return document.removeEventListener('click', this.closeOnClickaway)
                }

                if (!this.$refs.help.contains(e.target)) {
                    this.showPopover = false
                }
            }
        },
        watch: {
            showPopover (shown) {
                if (shown) {
                    document.addEventListener('click', this.closeOnClickaway)
                } else {
                    document.removeEventListener('click', this.closeOnClickaway)
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/general/HelpText.vue